export default (form, field, newValue, otherValue = null) => {
  form[field].value = newValue;
  const invalidFields = Object.values(form).filter((formItem) => {
    const { validation, value, length } = formItem;
    switch (validation) {
      case 'email':
        const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return !regex.test(value);
        break;
      case 'required':
        return !value || value.trim() === '';
        break;
      case 'length':
        return !value || value.length !== length;
        break;
      case 'minLength':
        return !value || value.length < length;
        break;
      case 'confirmation':
        return !value || value !== otherValue;
        break;
      case 'phone':
        return !value || (value.replace(/\D/g, '').length < 10);
        break;
      case 'notNull':
        return !value;
        break;
      default:
        return true;
    }
  });

  const canSubmit = invalidFields.length === 0;
  return { canSubmit, form };
};



// WEBPACK FOOTER //
// ./src/lib/FormValidation.js